export function getDefaultSectionLength(section, defaultItemHeight) {
  return defaultItemHeight
    ? `${section.length * defaultItemHeight.replace('px', '')}px`
    : null;
}

export function divideSections(data, itemsPerSection) {
  return data.reduce((arr, item, index) => {
    const pos = parseInt(index / itemsPerSection, 10);
    if (arr[pos]) {
      arr[pos].push(item);
    } else {
      arr.push([item]);
    }
    return arr;
  }, []);
}
